import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { Resultado } from '../../core/resultado.js';
import type { Usuario, NovoUsuario, PapelUsuario } from '@pgcustom/shared-types';

/** Adapter do módulo Usuários (admin) no frontend — único ponto que conhece o formato das rotas `/api/v1/auth/usuarios*` (`apps/api/src/modules/auth/auth.routes.ts`). */
export class UsuariosApi {
  constructor(private readonly api: ApiClient) {}

  async listar(): Promise<Resultado<Usuario[]>> {
    try {
      const resposta = await this.api.get<{ usuarios: Usuario[] }>('/auth/usuarios');
      if (resposta.usuarios.length === 0) return { status: 'vazio' };
      return { status: 'ok', dado: resposta.usuarios };
    } catch (erro) {
      if (erro instanceof ApiError && erro.status === 403) return { status: 'sem-permissao' };
      return { status: 'erro', mensagem: erro instanceof ApiError ? erro.message : 'falha ao carregar usuários' };
    }
  }

  async criar(dado: NovoUsuario): Promise<Usuario> {
    const resposta = await this.api.post<{ usuario: Usuario }>('/auth/usuarios', dado);
    return resposta.usuario;
  }

  async alterarPapel(id: string, papel: PapelUsuario): Promise<Usuario> {
    const resposta = await this.api.patch<{ usuario: Usuario }>(`/auth/usuarios/${id}/papel`, { papel });
    return resposta.usuario;
  }

  async alterarStatus(id: string, ativo: boolean): Promise<Usuario> {
    const resposta = await this.api.patch<{ usuario: Usuario }>(`/auth/usuarios/${id}/status`, { ativo });
    return resposta.usuario;
  }
}
